import { useMemo } from 'react';

import { SiteConfigManager, useSettings } from '@atlas/core';

const useLanguage = () => {
  const { lang } = useSettings();

  return useMemo(() => {
    const currentLang = SiteConfigManager.getConfig('languages')?.find(
      language => language.code === lang,
    );

    return {
      alpha2Code: currentLang?.alpha2Code,
      alpha3Code: currentLang?.alpha3Code,
      hreflang: currentLang?.hreflang,
    };
  }, [lang]);
};

export default useLanguage;
